import { FormGroup } from '@angular/forms';
import { CreateUserLoginComponent } from './create-user-login/create-user-login.component';
import {
  BaseControl,
  TablaMaestra,
  ColumnaMaestra,
  Valores,
  EstructuraEspecifica,
  InformacionTablaMaestra,
  FiltroTableMasterGeneral,
  ValoresEspecificos,
  Static,
  ColumnsTableModalSelect,
  AccionModal,
  SubForma,
  Const,
  ModalTableComponent,
  ButtonsModalTable,
  ConfirmComponent
} from '@app/shared';
import { TeacherDataService } from './shared/teacher-data.service';
import { TeacherFormService } from './shared/teacher-form.service';
import { TeacherConfigService } from './shared/teacher-config.service';
import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  Logger,
  GlobalInfoService,
  GlobalNotifierService,
  AuthenticationService
} from '@app/core';
import { find, findIndex, forEach, indexOf, Partial } from 'lodash';
import { LocalDataSource } from 'ng2-smart-table';
import { TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

const log = new Logger('TeacherComponent');

@Component({
  selector: 'iw-teacher',
  templateUrl: './teacher.component.html',
  styleUrls: ['./teacher.component.scss'],
  providers: [TeacherFormService, TeacherDataService, TeacherConfigService],
})
export class TeacherComponent implements OnInit, OnDestroy {
  // Define la opcion de la tabla maestra seleccionada
  opcion = '';
  // Define el nombre de la tabla maestra a la que se le desea realizar la accion de modificar o actualizar
  masterTable = '';
  // Define la clase del boton de los formularios
  claseButton = '';
  // Define el texto de el boton submit de los formularios
  textoButton = '';
  // Define la pregunta del componente de confirmacion
  question = '';
  // Define la pregunta del modal de la tabla
  questionTable = '';
  // Accion que se esta realizando
  actionRow = 'Agregar';
  // Mensaje del componente de no encontrado
  messageEmpty = 'Debe seleccionar una tabla maestra';
  // Define si se ha seleccionado algo en el combo principal de las tablas maestras
  selection = false;
  // Define si se ha presionado el boton de agregar o modificar
  action = false;
  // Define si la accion a realizar es modificar o actualizar
  modificar = false;
  // Define si la tabla seleccionada es una dinamica
  dynamicMasterTable = false;
  // Define cuando se realiza una accion a una maestra dinamica
  actionMaster = false;
  // Define cuando se muestra la carga de la tabla
  loaderTable = false;
  // Define cuando se muestra el boton de buscar
  SearchButton = false;
  // Define cuando abrir el modulo de creacion de estructura
  structureM = false;
  // Define cuando una maestra no contiene estructura
  emptyStructure = false;
  // Define si la tabla maestra seleccionada pertenece a la maestra de usuarios
  masterTableUsers = false;
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    created: false,
    review: false,
    update: false,
    delete: false,
    estructure: false,
    createUserSystem: false,
    reviewUserSystem: false,
    updateUserSystem: false,
    deleteUserSystem: false,
    buildStructure: false,
    reviewStructure: false,
    deleteStructure: false,
  };
  // Clase base de los controles del formulario dinamico
  controls: BaseControl<any>[] = [];
  // Contiene los botones que apareceran en la modal de la tabla
  buttons: Array<ButtonsModalTable> = [];
  // Contiene los templetes de los campos personalizados del formulario
  templatesFomr = {};
  // Tablas maestras
  tablesMaster: Array<TablaMaestra> = [];
  // Contiene la estructura de la maestra
  structureMaster: Array<ColumnaMaestra> = [];
  // Tabla maestra seleccionada
  tableSelect: TablaMaestra;
  // Contiene el formulario renderizado
  currentForm: FormGroup;
  // Datos para llenar la tabla
  sourceData: LocalDataSource = new LocalDataSource();
  // Configuracion de la tabla
  settings = {};
  // Datos de los filtros de las tablas
  dataFilters: any = {
    tramites: [],
    typeSpecies: [],
    unitsMeasure: [],
    typeMobilization: [],
    classSisf: []
  };
  // Contiene los tramites del sistema para llenar el Typeahead de los formularios dinamicos
  tramites: any;
  // Contiene los tipos de especies para llenar los combox de los formularios dinamicos
  typeSpecies: any;
  // Contiene las unidades de medida para llenar los combox de los formularios dinamicos
  unitsMeasure: any;
  // Contiene los tipos de movilizacion para llenar los combox de los formularios dinamicos
  typeMobilization: any;
  // Contiene las clases de especies para llenar los combox de los formularios dinamicos
  classSisf: any;
  // Contiene el registro seleccionado de la tabla
  registroSeleccionado: any;
  // Contiene la data retornada por los formularios
  formData: any;
  // Define cuando esta accion una accion
  loadingProcess = false;
  // Mensaje de la ventan de cargando
  messaggeLoading = '';
// Variables utilizan modal selector
  // Accion que se esta realizando
  actionRowMS = 'Agregar';
  // Define el nombre de la tabla maestra a la que se le desea realizar la accion de modificar o actualizar
  masterTableMS = '';
  // Define si la accion a realizar es modificar o actualizar
  modificarMS = false;
  // Contiene el registro seleccionado de la tabla
  registroSeleccionadoMS: any;
  // Contiene la estructura de la maestra
  structureMasterMS: Array<ColumnaMaestra> = [];
  // Contiene el id de la tabla maestra
  idMasterTable = 0;
  // Contiene la data de la accion de la modal
  dataAccionModal: AccionModal;

  // Referencia de la modal
  modalRef: BsModalRef;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();


  tablePermission: any;
  deletePermission: boolean = false;
  createPermission: boolean = false;
  // update: boolean = false;
  // numero de registros de la tabla
  pageSize = 10;
  
  // Referencia al componente de confirmación
  @ViewChild('confirmAction') private confirmAction: ConfirmComponent;
  // Referencia al componente de confirmación de los selectores con modal
  @ViewChild('confirmActionSelectModal') private confirmActionSelectModal: ConfirmComponent;
  // Referencia al componente de el modal de acciones de la tabla
  @ViewChild('modalTable') private modalTable: ModalTableComponent;
  // Referencia al componente de el modal de acciones de la tabla
  @ViewChild('userLogin') private userLogin: CreateUserLoginComponent;
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
  // Referencia al componente de refactorizacion del formulario de la tabla maestra
  @ViewChild('templateRefactorMasterTable') private templateRefactorMasterTable: TemplateRef<any>;

  constructor(
    private tfs: TeacherFormService,
    private tds: TeacherDataService,
    private gis: GlobalInfoService,
    private modalService: BsModalService,
    private gns: GlobalNotifierService,
    private as: AuthenticationService,
    private toastr: ToastrService,
  ) {
  }

  ngOnInit() {

    // this.tds.getAdminUserMasterPermission().subscribe(data => {
    //   console.log(data);
    //   this.tablePermission = data;
    // })
    this.definePermissionsStructure();

    this.templatesFomr = {
      ngSelectTpl: this.ngSelectTpl,
    };
    // se setea el titulo de la vista actual
    this.gis.set({ title: 'Gestión de maestras' });
    // se consulta la lista de tablas maestras
    if (this.activateAction.review) {
      this.tds.getMasterTables().subscribe(data => {
        this.tablesMaster = data;
        this.tablesMaster.sort((a, b) => a.id - b.id);
        this.opcion = this.tablesMaster[0].nombre;
        this.dynamicTable();
      });
      

      this.tds.getAdminUserMasterPermission().subscribe( specifiPermission => {
        this.tablePermission = specifiPermission;
      });  
    } else {
      this.toastr.warning('Usted no posee permisos para ver las tablas maestras', 'Permiso denegado');
      this.messageEmpty = 'Usted no posee permisos para ver las tablas maestras';
    }
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Esta funcion carga las tablas dinamicamente dependiendo de la opcion selecionada en el combo principal de las
   * tablas maestras
   *
   * @param {*} [valor]
   * @memberof TeacherComponent
   */
  async dynamicTable(valor?: any) {
    
    this.loaderTable = true;
    if (valor != null) {
      this.opcion = valor;
    }
    this.modificar = false;
    this.registroSeleccionado = null;
    this.masterTableUsers = false;

    const configTable = new TeacherConfigService();
    this.sourceData.empty();
    this.tableSelect = find(this.tablesMaster, { nombre: this.opcion });
    if (this.tableSelect) {
      this.masterTableUsers = this.tableSelect.usuarios;
      this.buttons = [];
      this.definePermissions();
      if (this.activateAction.update) {
        this.buttons.push({ label: 'Modificar', class: 'btn-warning', value: 'modificar' });
      }
      if (this.activateAction.delete) {
        this.buttons.push({ label: 'Eliminar', class: 'btn-danger', value: 'eliminar' });
      }
      if (this.masterTableUsers) {
        if (
          this.activateAction.createUserSystem ||
          this.activateAction.reviewUserSystem ||
          this.activateAction.updateUserSystem ||
          this.activateAction.deleteUserSystem
        ) {
          // this.buttons.push({ label: 'Usuario del sistema', class: 'btn-info', value: 'login' });
        }
      }
      this.buttons.push({ label: 'Cancelar', value: 'cancelar' });
      this.SearchButton = false;
      this.dynamicMasterTable = true;
      const master = await this.tds.getInformacionMasterTable(this.tableSelect.id);
      let values = await this.tds.getInformacionBasicMasterTable(this.tableSelect.id,0,100)
      // master.valores.sort((a, b) => a.id - b.id);
      if (master.estructura.length) {
        this.structureMaster = master.estructura;
        this.settings = configTable.getDynamicColumns(this.structureMaster, this.masterTableUsers);
        await this.asyncForEach(this.structureMaster, async (field: ColumnaMaestra) => {
          await this.loadingSelectsTablePrincipal(field, master, values);
        });
        this.setTables(values);
        // this.sourceData.refresh();
        this.sourceData.onChanged().subscribe(async (change) => {
          if (change.action === 'page' && this.sourceData['data'].length) {
            let checkFilter = false;
            if (change.filter.filters.length){
              forEach(change.filter.filters,f=>{
                if(f.search !=""){
                  checkFilter = true;
                }
              })
            }
            if (!checkFilter){
              this.pageChange(change.paging.page, master);
            }
            
          }else if(change.action === 'filter' && this.sourceData['data'].length && change.filter.filters.length){
            let checkFilter = false;
            forEach(change.filter.filters,f=>{
              if(f.search !=""){
                checkFilter = true;
              }
            })
            if(checkFilter){
              this.SearchButton = true;
            }else{
              this.SearchButton = false;
              this.loaderTable = true;
              this.tds.getInformacionBasicMasterTable(this.tableSelect.id,0,100) //.toPromise()
                .then(async data => {
                    this.sourceData.empty();
                    await this.asyncForEach(this.structureMaster, async (field: ColumnaMaestra) => {
                      await this.loadingSelectsTablePrincipal(field, null, data);
                    });
                    data.forEach(col => {
                      col.datos['id'] = col.id;
                      if (this.masterTableUsers) {
                        col.datos['user_login'] = col.user_login;
                        if (col.user_login) {
                          col.datos['login'] = 'Sí';
                        } else {
                          col.datos['login'] = 'No';
                        }
                      }
                      this.sourceData.add(col.datos);
                    });
                    this.sourceData.getAll().then(d => this.sourceData.load(d))
                    this.loaderTable = false;
                })
            }
          }
        });
        this.selection = true;
        this.emptyStructure = false;
        this.messageEmpty = 'Debe seleccionar una tabla maestra';
      } else {
        this.structureMaster = [];
        this.selection = false;
        this.emptyStructure = true;
        this.loaderTable = false;
        this.messageEmpty = 'La maestra seleccionada no contiene una estructura';
      }
    } else {
      this.selection = false;
      this.dynamicMasterTable = false;
      this.loaderTable = false;
      this.emptyStructure = false;
      this.messageEmpty = 'Debe seleccionar una tabla maestra';
    }

    this.definePermissionsStructure();
  }

  /**
   * Realiza la estructura para la consulta de las columnas seleccionadas para mostrar en las tablas y selects
   *
   * @param {ColumnaMaestra[]} structure
   * @param {Array<string>} columns
   * @param {number} [idDependence=0]
   * @returns {EstructuraEspecifica}
   * @memberof TeacherComponent
   */
  loadingEstructureColumns(
    structure: ColumnaMaestra[],
    columns: Array<string>,
    idDependence: number = 0
  ): EstructuraEspecifica {
    let specificEstructure: EstructuraEspecifica;
    const cls: Array<string> = [];
    specificEstructure = {
      maestra: null,
      columnas: [],
      dependencia: []
    };

    columns.forEach(el => {
      cls.push(el);
    });

    for (const field of structure) {
      if (field.tipo_campo['nombre'] === 'ngSelect') {
        if (idDependence !== 0 && idDependence !== field.id) {
          continue;
        }
        specificEstructure.maestra = field.id + ' ';
        cls.forEach((col: string, index: number) => {
          const cols = col.split('_');
          const column = Number(cols[1]);
          if (cols.length === 2) {
            const dependenc = Number(cols[0]);
            if (typeof field.maestra_dependencia === 'object') {
              const columnField = find(field.maestra_dependencia.estructura, { id: column });
              if (dependenc === field.id) {

                if (columnField) {
                  specificEstructure.columnas.push(column + ' ');
                }
              }
            }
          } else if (cols.length > 2) {
            const cl = cols.slice(1);
            cls[index] = '';
            cl.forEach((el: any, indexCol: number) => {
              cls[index] += el;

              if (indexCol < (cl.length - 1)) {
                cls[index] += '_';
              }

            });
          }
        });
        if (cls.length) {
          const newLevel = this.loadingEstructureColumns(field.maestra_dependencia['estructura'], cls);
          if (newLevel) {
            specificEstructure.dependencia.push(newLevel);
            break;
          }
        }
      }
    }
    if (specificEstructure.maestra && (specificEstructure.columnas.length || specificEstructure.dependencia.length)) {
      return specificEstructure;
    } else {
      return null;
    }
  }

  /**
   * Setea la configuracion de la tabla
   *
   * @param {*} data
   * @memberof TeacherComponent
   */
  setTables(data: any) {
    if (this.dynamicMasterTable) {
      const valuesTable: Valores[] = data;
      const dataValues: Array<any> = [];
      valuesTable.forEach(col => {
        col.datos['id'] = col.id;
        if (this.masterTableUsers) {
          col.datos['user_login'] = col.user_login;
          if (col.user_login) {
            col.datos['login'] = 'Sí';
          } else {
            col.datos['login'] = 'No';
          }
        }
        dataValues.push(col.datos);
      });
      this.sourceData = new LocalDataSource(dataValues);
    } else {
      this.sourceData = new LocalDataSource(data);
    }
    this.sourceData.refresh();
    this.loaderTable = false;
  }

  /**
   * controla la respuesta de la comfirmacion
   *
   * @param {boolean} res
   * @memberof TeacherComponent
   */
  actionComfirm(res: boolean) {
    if (res) {
      if (this.formData != null) {
        this.sended(this.formData);
      } else {
        this.delete();
      }
    } else {
      if (this.formData != null) {
        this.formData = null;
      }
    }
  }

  /**
   * Controla la respuesta del modal de la tabla
   *
   * @param {String} res
   * @memberof TeacherComponent
   */
  modalTableAction(res: String) {
    switch (res) {
      case 'modificar':
        this.dynamicForm();
        break;
      case 'login':
        this.userLogin.idRegistration = this.registroSeleccionado['id'];
        if (this.registroSeleccionado['user_login']) {
          this.userLogin.userLogin = this.registroSeleccionado['user_login'];
        } else {
          this.userLogin.userLogin = null;
        }
        this.userLogin.open();
        break;
      case 'eliminar':
        this.confirm();
        break;
    }
  }

  /**
   * Esta funcion se ejecuta antes de abrir el formulario para agregar un registro en una de las tablas maestras
   * reinicia las variables principales de la accion modificar configurando todo para proceder a ingresar un registro
   *
   * @param {boolean} [addMaster=false]
   * @memberof TeacherComponent
   */
  add(addMaster: boolean = false) {
    this.modificar = false;
    this.registroSeleccionado = null;
    this.actionMaster = addMaster;
    this.actionRow = 'Agregar';
    this.dynamicForm();
  }

   /**
   * Esta funcion se ejecuta para filtar datos de tablas
   *
   * @param {Any} source
   * @memberof TeacherComponent
   */
    filterData(source: any) {
      if(source.filterConf && source.filterConf.filters.length){
        let filterFields: any[] = []
        forEach(source.filterConf.filters, (fil:any)=>{
          if(fil.search != ""){filterFields.push({"column":fil.field,"valor":fil.search})}
        })
        if (filterFields.length){
          this.loaderTable = true;

          this.tds.getInformacionBasicMasterTableFilter(this.tableSelect.id,0,0,filterFields) //.toPromise()
        .then(async data => {
            this.sourceData.empty();
            await this.asyncForEach(this.structureMaster, async (field: ColumnaMaestra) => {
              await this.loadingSelectsTablePrincipal(field, null, data);
            });
            // const dataValues: Array<any> = [];
            data.forEach(col => {
              col.datos['id'] = col.id;
              if (this.masterTableUsers) {
                col.datos['user_login'] = col.user_login;
                if (col.user_login) {
                  col.datos['login'] = 'Sí';
                } else {
                  col.datos['login'] = 'No';
                }
              }
              this.sourceData.add(col.datos);
            });
            this.sourceData.getAll().then(d => this.sourceData.load(d))
            this.loaderTable = false;
        })
        }else{
          this.tds.getInformacionBasicMasterTable(this.tableSelect.id,0,100) //.toPromise()
        .then(async data => {
            this.loaderTable = true;
            this.sourceData.empty();
            await this.asyncForEach(this.structureMaster, async (field: ColumnaMaestra) => {
              await this.loadingSelectsTablePrincipal(field, null, data);
            });
            data.forEach(col => {
              col.datos['id'] = col.id;
              if (this.masterTableUsers) {
                col.datos['user_login'] = col.user_login;
                if (col.user_login) {
                  col.datos['login'] = 'Sí';
                } else {
                  col.datos['login'] = 'No';
                }
              }
              this.sourceData.add(col.datos);
            });
            this.sourceData.getAll().then(d => this.sourceData.load(d))
            this.loaderTable = false;
        })
        }
        
      }else{
        this.loaderTable = true;
        this.tds.getInformacionBasicMasterTable(this.tableSelect.id,0,100) //.toPromise()
        .then(async data => {
          if (this.sourceData.count() > 0){
            this.sourceData.empty();
            await this.asyncForEach(this.structureMaster, async (field: ColumnaMaestra) => {
              await this.loadingSelectsTablePrincipal(field, null, data);
            });
            // const dataValues: Array<any> = [];
            data.forEach(col => {
              col.datos['id'] = col.id;
              if (this.masterTableUsers) {
                col.datos['user_login'] = col.user_login;
                if (col.user_login) {
                  col.datos['login'] = 'Sí';
                } else {
                  col.datos['login'] = 'No';
                }
              }
              this.sourceData.add(col.datos);
            });
            // forEach(data, d => this.sourceData.add(d));
            // this.sourceData.getAll()
            // .then(d => this.sourceData.load(d))
            this.sourceData.getAll().then(d => this.sourceData.load(d))
            this.loaderTable = false;
        }
          else{
            this.sourceData.load(data);
          }
        })
      }  
    }

  /**
   * Esta funcion cierra la vista de los formularios y vuelve a cargar los datos de la vista principal
   *
   * @param {boolean} [updateTable=false]
   * @memberof TeacherComponent
   */
  closeForm(updateTable: boolean = false) {
    if (this.actionMaster) {
      this.tds.getMasterTables().subscribe(data => {
        this.masterTable = '';
        this.action = false;
        this.tablesMaster = data;
        this.tablesMaster.sort((a, b) => a.id - b.id);
        this.dynamicTable();
      });
    } else {
      delete this.currentForm;
      this.masterTable = '';
      this.action = false;
      if (updateTable) {
        this.dynamicTable();
      }
    }
  }

  /**
   * Funcion de el modal de confirmacion
   *
   * @param {*} [data=null]
   * @memberof TeacherComponent
   */
  confirm(data: any = null) {
    if (data) {
      this.formData = data;
      if (this.modificar) {
        this.question = '¿Realmente desea actualizar el registro?';
      } else {
        this.question = '¿Realmente desea agregar el registro?';
      }
    } else {
      this.actionMaster = false;
      this.formData = null;
      this.question = '¿Realmente desea eliminar el registro?';
    }
    setTimeout(() => {
      this.confirmAction.open();
    }, 500);
  }

  /**
   * Confirmacion de la eliminacion de las tablas maestras
   *
   * @memberof TeacherComponent
   */
  comfirmDeleteMasterTable() {
    this.actionMaster = true;
    delete this.formData;
    this.question = '¿Realmente desea eliminar la tabla maestra?';
    this.registroSeleccionado = this.tableSelect;
    this.confirmAction.open();
  }

  /**
   * Esta funcion controla el evento al dar click en un registro de la tabla
   *
   * @param {*} data
   * @memberof TeacherComponent
   */
  onCellClick(data: any) {
    if (this.buttons && this.buttons.length > 1) {
      this.actionMaster = false;
      this.registroSeleccionado = data.data;
      this.modificar = true;
      this.actionRow = 'Modificar';
      this.openModalTable();
    } else {
      this.toastr.warning(
        'Usted no posee permisos de modificar o eliminar los registro de las tablas maestras',
        'Permiso denegado'
      );
    }
  }

  /**
   * Prepara la informacion para modificar la tabla maestra
   *
   * @memberof TeacherComponent
   */
  updateDinamicMaster() {
    this.tableSelect = find(this.tablesMaster, { nombre: this.opcion });
    if (this.tableSelect) {
      this.actionMaster = true;
      this.registroSeleccionado = this.tableSelect;
      this.modificar = true;
      this.actionRow = 'Modificar';
      this.dynamicForm();
    }
  }

  /**
   * Crea la subcripcion de cambias al formulario de agregacion o modificacion de registro
   *
   * @param {FormGroup} form
   * @memberof TeacherComponent
   */
  formCreate(form: FormGroup) {
    if (form && !this.actionMaster) {
      this.currentForm = form;
      this.structureMaster.forEach(field => {
        this.currentForm.controls[field.id + ' '].valueChanges.subscribe(async value => {
          const fieldsDependence = this.selectDependencia(this.structureMaster, field.alias);
          const data = this.getDataForm(this.currentForm, this.structureMaster);
          if (field.tipo_campo['nombre'] === 'ngSelect' && fieldsDependence) {
            await this.asyncForEach(fieldsDependence, async (fieldF: ColumnaMaestra) => {
              await this.loadingSelectsOptions(fieldF, data);
            });
          }
        });
      });
    }
  }

  /**
   * Consulta todas las columnas que dependen de la columna
   *
   * @private
   * @param {ColumnaMaestra[]} fields
   * @param {string} nameControl
   * @returns {ColumnaMaestra[]}
   * @memberof TeacherComponent
   */
  private selectDependencia(fields: ColumnaMaestra[], nameControl: string): ColumnaMaestra[] {
    const fieldsDependenci: ColumnaMaestra[] = [];
    fields.forEach(field => {
      if (field.validaciones && field.validaciones.filtros && field.validaciones.filtros.length) {
        const controlContent = find(field.validaciones.filtros, {field: nameControl});
        if (controlContent) {
          fieldsDependenci.push(field);
        }
      }
    });
    return fieldsDependenci;
  }

  /**
   * Retorna la informacion ingresada en el formulario mapiado en json con la estructura de la maestra
   *
   * @private
   * @param {FormGroup} formData
   * @param {ColumnaMaestra[]} structure
   * @returns {Object}
   * @memberof TeacherComponent
   */
  private getDataForm(formData: FormGroup, structure: ColumnaMaestra[]): Object {
    const data = {};
    structure.forEach(field => {
      let value: any;
      if (
        formData && formData.controls &&
        typeof field.tipo_campo === 'object' &&
        field.tipo_campo.nombre !== 'checkbox' &&
        field.tipo_campo.nombre !== 'coordenadas'
      ) {
        if (formData.controls[field.id + ' ']) {
          value = formData.controls[field.id + ' '].value;
        }
      }
      if (typeof field.tipo_campo === 'object' && field.tipo_campo.nombre === 'checkbox') {
        value = false;
        if (formData && formData.controls) {
          if (formData.controls[field.id + ' '].value) {
            value = formData.controls[field.id + ' '].value;
          }
        }
        if (formData.controls.hasOwnProperty(field.id + ' ')) {
          data[field.id + ' '] = value;
        }
      } else if (typeof field.tipo_campo === 'object' && field.tipo_campo.nombre === 'date-time-picker') {
        data[field.id + ' '] = value;
      } else if (typeof field.tipo_campo === 'object' && field.tipo_campo.nombre === 'ngSelect') {
        data[field.id + ' '] = value;
      } else if (formData.controls[field.id + ' ']) {
        data[field.id + ' '] = value;
      }
    });
    return data;
  }

  /**
   * define el mensaje ha mostrar y abre el modal de la tabla
   * @private
   * @memberof TeacherComponent
   */
  private openModalTable() {
    this.questionTable = '';
    this.questionTable = '¿Que accion desea realizar?';
    this.modalTable.openModal();
  }

  /**
   * Esta funcion renderiza los formularios dependiendo de la opcion seleccionada en el combo principal de las tablas
   * maestras dectetando si se desea modificar o ingresar
   *
   * @private
   * @param {*} [dataForm]
   * @memberof TeacherComponent
   */
  private async dynamicForm() {
    let objectModel: any;
    if (this.modificar) {
      objectModel = this.registroSeleccionado;
      this.claseButton = 'btn-warning';
      this.textoButton = 'Modificar';
    } else {
      this.claseButton = 'btn-success';
      this.textoButton = 'Agregar';
    }
    if (!this.actionMaster) {
      if (this.opcion !== '') {
        this.tableSelect = find(this.tablesMaster, { nombre: this.opcion });
        if (this.tableSelect) {
          await this.asyncForEach(this.structureMaster, async (field: ColumnaMaestra) => {
            await this.loadingSelectsOptions(field, objectModel);
          });
          this.masterTable = this.tableSelect.nombre;
          this.action = true;
        } else {
          this.masterTable = '';
          this.action = false;
        }
      }
    } else {
      this.action = true;
      if (this.modificar) {
        objectModel = this.registroSeleccionado;
        this.claseButton = 'btn-warning';
        this.textoButton = 'Modificar';
      } else {
        this.claseButton = 'btn-success';
        this.textoButton = 'Agregar';
      }
      this.controls = this.tfs.getFieldsDynamicTable(objectModel);
      this.masterTable = 'Maestra';
      if (this.registroSeleccionado) {
        this.masterTable += ' ' + this.registroSeleccionado.nombre;
      }
    }
  }

  /**
   * Esta funcion se encarga de cargar los modelos con la informacion ingresada en los formularios dependiendo
   * de la tabla maestra a la cual se le desea realizar la accion detetando si se ingresa o modifica el registro
   *
   * @private
   * @param {*} data
   * @memberof TeacherComponent
   */
  private sended(data: any) {
    if (!this.actionMaster) {
      const valid = this.validDataForm(data, this.structureMaster);
      if (valid) {
        this.tableSelect = find(this.tablesMaster, { nombre: this.opcion });
        if (this.tableSelect) {
          if (this.modificar) {
            this.tds.updateInformationDynamicTableMaster(this.registroSeleccionado['id'], data).subscribe(res => {
              if (res) {
                this.closeForm(true);
              }
            });
          } else {
            this.tds.addInformationDynamicTableMaster(this.tableSelect.id, data).subscribe(res => {
              if (res) {
                this.closeForm(true);
              }
            });
          }
        }
      }
    } else {
      const tableN: TablaMaestra = {
        nombre: data.txtNombre,
        descripcion: data.txtDescripcion,
        alias: data.txtAlias,
        usuarios: false
      };
      if (this.modificar) {
        this.tds.updateMasterTable(this.registroSeleccionado['id'], tableN).subscribe(res => {
          if (res) {
            this.opcion = tableN.nombre;
            this.closeForm(true);
          }
        });
      } else {
        this.tds.addMasterTable(tableN).subscribe(res => {
          if (res) {
            this.opcion = tableN.nombre;
            this.closeForm(true);
          }
        });
      }
    }
  }

  /**
   * Esta funcion se encarga enviar las peticion al servicio para eliminar el registro seleccionado
   * detetando de cual tabla maestra se selecciono
   *
   * @private
   * @memberof TeacherComponent
   */
  private delete() {
    const idregistro = this.registroSeleccionado['id'];
    if (!this.actionMaster) {
      this.tableSelect = find(this.tablesMaster, { nombre: this.opcion });
      if (this.tableSelect) {
        this.tds.deleteInformationDynamicTableMaster(idregistro).subscribe(res => {
          if (res) {
            this.closeForm(true);
          } else {
            log.debug('No se pudo eliminar el registro.');
          }
        });
      }
    } else {
      this.tds.deleteMasterTable(idregistro).subscribe(res => {
        if (res) {
          this.opcion = '';
          this.closeForm(true);
        }
      });
    }
  }

  /**
   * Abre el modulo de edicion de estructura de la maestra
   *
   * @memberof TeacherComponent
   */
  openStructureMaster() {
    this.structureM = true;
  }

  /**
   * Cierra el modulo de edicion de estructura de la maestra
   *
   * @param {boolean} res
   * @memberof TeacherComponent
   */
  closeStructure(res: boolean) {
    if (res) {
      this.dynamicTable();
    }
    this.structureM = false;
  }

  /**
   * Ejecuta un for de forma sincronica
   *
   * @private
   * @param {Array<any>} array
   * @param {*} callback
   * @memberof TeacherComponent
   */
  private async asyncForEach(array: Array<any>, callback: any) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
      continue;
    }
  }

  /**
   * Refresca las opciones de los selects
   *
   * @private
   * @param {ColumnaMaestra} field
   * @param {*} [data]
   * @returns {Promise<any>}
   * @memberof TeacherComponent
   */
  private async loadingSelectsOptions(
    field: ColumnaMaestra,
    data?: any,
    refreshForm: boolean = true
  ): Promise<any> {
    return new Promise(async (resolve) => {
      if (field.tipo_campo['nombre'] === 'ngSelect') {
        const columnsMaster: Array<{
          key: string,
          value: number
        }> = [];
        let specificEstructure: EstructuraEspecifica;
        let columns: ValoresEspecificos[] = [];
        const filterMaster: FiltroTableMasterGeneral[] = [];

        specificEstructure = {
          maestra: field.maestra_dependencia['id'],
          columnas: [],
          dependencia: []
        };
        // Se crea la estructura de la consulta de las columnas relacionadas a la maestra para el ngselect
        field.propiedades['columnas_seleccionadas'].forEach((col: string, index: number) => {
          const cols = col.split('_');
          const column = Number(cols[0]);
          if (cols.length === 1) {
            if (typeof field.maestra_dependencia === 'object') {
              const structure = find(field.maestra_dependencia.estructura, { id: column });

              if (structure) {
                // field.propiedades['columnas_seleccionadas'].slice(index, 1);
                specificEstructure.columnas.push(column + ' ');
              }
            }
          }
        });
        if (field.propiedades['columnas_seleccionadas'].length) {
          const blockColumns: Array<string[]> = [];
          if (field.propiedades['columnas_seleccionadas']) {
            let columnDependence = '';
            field.propiedades['columnas_seleccionadas'].forEach((col: string, index: number) => {
              const column = col.split('_');
              if (column.length > 1) {
                if (columnDependence !== column[0]) {
                  columnDependence = column[0];
                  const blockColumnsRecolector: Array<string> = [];
                  field.propiedades['columnas_seleccionadas'].forEach((colDep: string, indexDep: number) => {
                    const columnsRef = colDep.split('_');
                    if (columnsRef[0] === columnDependence) {
                      blockColumnsRecolector.push(colDep);
                    }
                  });
                  blockColumns.push(blockColumnsRecolector);
                }
              }
            });
          }
          blockColumns.forEach(columnsSeleted => {
            const history = this.loadingEstructureColumns(
              field.maestra_dependencia['estructura'],
              columnsSeleted,
              Number(columnsSeleted[0].split('_')[0])
            );

            if (history) {
              specificEstructure.dependencia.push(history);
            }
          });
        }
        if (field.validaciones && field.validaciones.filtros && field.validaciones.filtros.length) {
          field.validaciones.filtros.forEach(filter => {
            if (filter.columna) {
              let valorField: any;
              if (filter.field) {
                const control = find(this.structureMaster, {alias: filter.field});
                if (control) {
                  if (data) {
                    valorField = data[control.id + ' '];
                  } else {
                    if (this.currentForm) {
                      valorField = this.currentForm.controls[control.id + ' '].value;
                    }
                  }
                }
              }  else {
                valorField = filter.valor;
              }
              if (!valorField) {
                valorField = '';
              }

              if (filter.operador && (filter.operador === 'LIKE' || filter.operador === 'ILIKE')) {
                valorField = '%' + valorField + '%';
              }

              const cols = filter.columna.split('_');
              if (cols.length && cols.length > 1) {
                if (filter.condicional) {
                  filterMaster.push({
                    maestra: cols[cols.length - 2],
                    columna: cols[cols.length - 1],
                    valor: valorField,
                    operador: filter.operador ? filter.operador : '=',
                    condicional: filter.condicional
                  });
                } else {
                  filterMaster.push({
                    maestra: cols[cols.length - 2],
                    columna: cols[cols.length - 1],
                    valor: valorField,
                    operador: filter.operador ? filter.operador : '=',
                  });
                }
              } else {
                if (filter.condicional) {
                  filterMaster.push({
                    columna: cols[cols.length - 1],
                    valor: valorField,
                    operador: filter.operador ? filter.operador : '=',
                    condicional: filter.condicional
                  });
                } else {
                  filterMaster.push({
                    columna: cols[cols.length - 1],
                    valor: valorField,
                    operador: filter.operador ? filter.operador : '=',
                  });
                }
              }
            }
          });
        }
        let validSearch = false;
        if (filterMaster.length === 1) {
          if (filterMaster[0].operador === 'IS NULL' || filterMaster[0].operador === 'IS NOT NULL') {
            validSearch = true;
          } else {
            if (filterMaster[0].valor) {
              validSearch = true;
            }
          }
        } else if (filterMaster.length > 1) {
          validSearch = true;
        } else if (!filterMaster.length) {
          validSearch = true;
        }
        if (validSearch) {
          columns = await this.tds.getColumnsSpecificMasterTable(specificEstructure, filterMaster);
        }
        // se setean los labels a mostrar en el select
        columns.forEach(column => {
          let labelSelect = '';
          field.propiedades['columnas_seleccionadas'].forEach((col: string, index: any) => {
            if (index > 0) {
              labelSelect += ' / ';
            }
            if (column.valores[col]) {
              labelSelect += column.valores[col];
            } else {
              labelSelect += 'No aplica';
            }
          });
          columnsMaster.push({ value: column.id, key: labelSelect });
        });
        if (field.propiedades['tipoSelector'] && field.propiedades['tipoSelector'] === 'EnModal') {
          const dataModalSelector: Array<any> = [];
            columns.forEach(row => {
              const d = Static.copyObjet(row.valores);
              d['id'] = row.id;
              dataModalSelector.push(d);
            });
            field.propiedades['dataSelectorModal'] = dataModalSelector;
        }
        field.propiedades['options'] = columnsMaster;
      }
      if (refreshForm) {
        this.controls = this.tfs.getFieldsDynamicTableStructure(
          this.structureMaster,
          this.templatesFomr,
          data
        );
        const ctrl = find(this.controls[0]['controls'], {key: field.id + ' '});
        if (ctrl) {
          if (this.currentForm && this.currentForm.controls[field.id + ' ']) {
            this.currentForm.controls[field.id + ' '].setValue(ctrl['value']);
          }
        }
      }
      resolve(true);
    });
  }

  /**
   * Carga cada uno de los labels del selects de los registros de la tabla
   *
   * @private
   * @param {ColumnaMaestra} field
   * @param {InformacionTablaMaestra} [master]
   * @returns {Promise<any>}
   * @memberof TeacherComponent
   */
  private async loadingSelectsTablePrincipal(
    field: ColumnaMaestra,
    master?: InformacionTablaMaestra,
    values?: Valores[]
  ): Promise<any> {
    return new Promise(async (resolve) => {
      if (field.tipo_campo['nombre'] === 'ngSelect') {
        let specificEstructure: EstructuraEspecifica;
        let columns: ValoresEspecificos[] = [];
        const filterMaster: FiltroTableMasterGeneral[] = [];

        specificEstructure = {
          maestra: field.maestra_dependencia['id'],
          columnas: [],
          dependencia: []
        };
        // Se crea la estructura de la consulta de las columnas relacionadas a la maestra para el ngselect
        field.propiedades['columnas_seleccionadas'].forEach((col: string, index: number) => {
          const cols = col.split('_');
          const column = Number(cols[0]);
          if (cols.length === 1) {
            if (typeof field.maestra_dependencia === 'object') {
              const structure = find(field.maestra_dependencia.estructura, { id: column });
              if (structure) {
                specificEstructure.columnas.push(column + ' ');
              }
            }
          }
        });
        if (field.propiedades['columnas_seleccionadas'].length) {
          const blockColumns: Array<string[]> = [];
          if (field.propiedades['columnas_seleccionadas']) {
            let columnDependence = '';
            field.propiedades['columnas_seleccionadas'].forEach((col: string, index: number) => {
              const column = col.split('_');
              if (column.length > 1) {
                if (columnDependence !== column[0]) {
                  columnDependence = column[0];
                  const blockColumnsRecolector: Array<string> = [];
                  field.propiedades['columnas_seleccionadas'].forEach((colDep: string, indexDep: number) => {
                    const columnsRef = colDep.split('_');
                    if (columnsRef[0] === columnDependence) {
                      blockColumnsRecolector.push(colDep);
                    }
                  });
                  blockColumns.push(blockColumnsRecolector);
                }
              }
            });
          }
          blockColumns.forEach(columnsSeleted => {
            const history = this.loadingEstructureColumns(
              field.maestra_dependencia['estructura'],
              columnsSeleted,
              Number(columnsSeleted[0].split('_')[0])
            );

            if (history) {
              specificEstructure.dependencia.push(history);
            }
          });
        }
        // Se setea el valor a mostrar en la columna de la tabla
        // if (master && master.valores && master.valores.length) {
        //   let listIdMaster = '(';
        //   const idMaster: Array<any> = [];
        //   const searchValues: Array<{
        //     id: number,
        //     data: string,
        //   }> = [];

        //   master.valores.forEach((val, index) => {
        //     if (val.datos[field.id + ' ']) {
        //       const idExist = indexOf(idMaster, val.datos[field.id + ' ']);
        //       if (idExist === -1) {
        //         if (index && index <= (master.valores.length - 1) && listIdMaster !== '(') {
        //           listIdMaster += ', ';
        //         }
        //         idMaster.push(val.datos[field.id + ' ']);
        //         listIdMaster += val.datos[field.id + ' '];
        //       }
        //     }
        //   });
        //   listIdMaster += ')';
        //   if (listIdMaster !== '()') {
        //     columns = await this.tds.getColumnsSpecificMasterTable(
        //       specificEstructure,
        //       null,
        //       listIdMaster
        //     );
        //   }
        //   await this.asyncForEach(master.valores, async (val: Valores) => {
        //     let labelSelect = '';
        //     const search = find(searchValues, {id: val.datos[field.id + ' ']});
        //     if (!search) {
        //       if (val.datos[field.id + ' ']) {
        //         const column = find(columns, { id: val.datos[field.id + ' '] });
        //         if (column) {
        //           field.propiedades['columnas_seleccionadas'].forEach((col: string, index: any) => {
        //             if (index > 0) {
        //               labelSelect += ' / ';
        //             }
        //             if (column.valores[col]) {
        //               labelSelect += column.valores[col];
        //             } else {
        //               labelSelect += 'No aplica';
        //             }
        //           });

        //           searchValues.push({
        //             id: column.id,
        //             data: labelSelect
        //           });
        //         }
        //       }
        //     } else {
        //       labelSelect = search.data;
        //     }
        //     val.datos[field.id + '_valor'] = labelSelect;
        //   });
        // }
        if (values && values.length) {
          let listIdMaster = '(';
          const idMaster: Array<any> = [];
          const searchValues: Array<{
            id: number,
            data: string,
          }> = [];

          values.forEach((val, index) => {
            if (val.datos[field.id + ' ']) {
              const idExist = indexOf(idMaster, val.datos[field.id + ' ']);
              if (idExist === -1) {
                if (index && index <= (values.length - 1) && listIdMaster !== '(') {
                  listIdMaster += ', ';
                }
                idMaster.push(val.datos[field.id + ' ']);
                listIdMaster += val.datos[field.id + ' '];
              }
            }
          });
          listIdMaster += ')';
          if (listIdMaster !== '()') {
            columns = await this.tds.getColumnsSpecificMasterTable(
              specificEstructure,
              null,
              listIdMaster
            );
          }
          await this.asyncForEach(values, async (val: Valores) => {
            let labelSelect = '';
            const search = find(searchValues, {id: val.datos[field.id + ' ']});
            if (!search) {
              if (val.datos[field.id + ' ']) {
                const column = find(columns, { id: val.datos[field.id + ' '] });
                if (column) {
                  field.propiedades['columnas_seleccionadas'].forEach((col: string, index: any) => {
                    if (index > 0) {
                      labelSelect += ' / ';
                    }
                    if (column.valores[col]) {
                      labelSelect += column.valores[col];
                    } else {
                      labelSelect += 'No aplica';
                    }
                  });

                  searchValues.push({
                    id: column.id,
                    data: labelSelect
                  });
                }
              }
            } else {
              labelSelect = search.data;
            }
            val.datos[field.id + '_valor'] = labelSelect;
          });
        }
      }
      resolve(true);
    });
  }

  /**
   * Cierra el modal del formulario renderizado de la tabla maestra
   *
   * @param {boolean} [loading=false]
   * @memberof TeacherComponent
   */
  closeModal(loading: boolean = false) {
    this.actionRow = 'Agregar';
    this.masterTable = '';
    this.modificar = false;
    this.registroSeleccionado = null;
    this.structureMaster = [];
    this.idMasterTable = 0;
    this.modalRef.hide();
    if (loading) {
      if (
        this.dataAccionModal.temporalData['form'] &&
        this.dataAccionModal.temporalData['control']
      ) {
        this.loadingModalSelector(
          this.dataAccionModal.temporalData['control']
        );
      }
    }
    this.dataAccionModal = null;
  }

  /**
   * Controla los eventos de accion del seletor en modal
   *
   * @param {AccionModal} data
   * @memberof TeacherComponent
   */
  async actionSelectModal(data: AccionModal) {
    
    log.debug(data);
    this.dataAccionModal = data;
    switch (data.accion) {
      case 'eliminar':
        this.confirmActionSelectModal.open();
        break;
      case 'agregar':
        this.actionRowMS = 'Agregar';
        this.masterTableMS = data.temporalData['nombre'];
        this.idMasterTable = data.temporalData['id'];
        this.modificarMS = false;
        this.registroSeleccionadoMS = null;
        this.structureMasterMS = data.temporalData['estructura'];
        this.openModalFormMasterTable();
        break;
      case 'actualizar':
        this.loadingProcess = true;
        this.messaggeLoading = 'Cargando el registro...';
        this.actionRowMS = 'Modificar';
        this.masterTableMS = data.temporalData['nombre'];
        this.idMasterTable = data.temporalData['id'];
        this.modificarMS = true;
        this.registroSeleccionadoMS = await this.tds.getInformationDynamicTableMaster(
          data.registroSeleccionado['id']
        ).catch(err => this.loadingProcess = false);
        this.structureMasterMS = data.temporalData['estructura'];
        this.openModalFormMasterTable();
        this.loadingProcess = false;
        break;
    }
  }

  /**
   * Elimina el regitro seleccionado
   *
   * @param {boolean} res
   * @memberof TeacherComponent
   */
  async deleteRowSelectModal(res: boolean) {
    if (res) {
      switch (this.dataAccionModal.accion) {
        case 'eliminar':
          const idregistro = this.dataAccionModal.registroSeleccionado['id'];
          this.tds.deleteInformationDynamicTableMaster(idregistro).subscribe(async resp => {
            if (resp) {
              if (
                this.dataAccionModal.temporalData['form'] &&
                this.dataAccionModal.temporalData['control']
              ) {
                this.loadingModalSelector(
                  this.dataAccionModal.temporalData['control']
                );
              }
              this.dataAccionModal = null;
            } else {
              log.debug('No se pudo eliminar el registro.');
            }
          });
          break;
      }
    }
  }

  /**
   * Abre el modal con el formulario renderizado de la tabla maestra
   *
   * @private
   * @memberof TeacherComponent
   */
  private openModalFormMasterTable() {
    this.modalRef = this.modalService.show(
      this.templateRefactorMasterTable,
        {
          class: 'modal-lg-personalized',
          backdrop: 'static'
        }
    );
  }

  /**
   * Carga las opciones del modal
   *
   * @private
   * @param {ColumnaMaestra} control
   * @memberof TeacherComponent
   */
  private async loadingModalSelector(control: ColumnaMaestra) {
    await this.loadingSelectsOptions(
      this.dataAccionModal.temporalData['control'],
      this.getDataForm(this.currentForm, this.dataAccionModal.temporalData['form']),
      false
    );

    let dataLoading: Array<any> = [];
    if (control.propiedades['dataSelectorModal']) {
      dataLoading = control.propiedades['dataSelectorModal'];
      log.debug('dataLoading', dataLoading);
    }
    this.gns.set<any>({
      source: 'TeacherComponent',
      destiny: 'ModalSelectComponent-' + control.id + ' ',
      action: 'loadingData',
      eventTriggered: 'click',
      data: <any> dataLoading
    }, true);
    this.dataAccionModal = null;
  }

  /**
   * Determina los permisos del usuario en sesion
   *
   * @private
   * @memberof TeacherComponent
   */
  private definePermissions() {
    
      let checkPermission: any = find(this.tablePermission, {id_maestra: this.tableSelect.id})
      
        if(checkPermission) {
          if (checkPermission.crear == true) {
            this.activateAction.created =  true;
          } else {
            // console.log('no crear');
            this.activateAction.created =  false;
          }


          if(checkPermission.ver == false) { 
            this.structureMaster = [];
            this.selection = false;
            this.emptyStructure = true;
            this.loaderTable = false;
            this.messageEmpty = 'La maestra seleccionada no contiene permisos';
            
          }

          if (checkPermission.modificar == true) {
            // console.log('modificar');
            this.activateAction.update = true;
            
          } else {
            // console.log('no modificar');
            this.activateAction.update =  false;
          }


          if (checkPermission.eliminar == true) {
            // console.log('eliminar');
            this.activateAction.delete = true;
          } else {
            // console.log('no eliminar');
            this.activateAction.delete = false;
          }

           // Permiso para crear usuario del sistema
           this.activateAction.createUserSystem = this.as.confirmPermission(
            Const.types_permissions.administrationMasterTables,
            Const.types_action_permissions.createUserSystem,
          );
          
          // Permiso para ver los usuarios del sistema
          this.activateAction.reviewUserSystem = this.as.confirmPermission(
            Const.types_permissions.administrationMasterTables,
            Const.types_action_permissions.reviewUserSystem,
          );
          
          // Permiso para modificar los usuarios del sistema
          this.activateAction.updateUserSystem = this.as.confirmPermission(
            Const.types_permissions.administrationMasterTables,
            Const.types_action_permissions.updateUserSystem,
          );

          // Permiso para eliminar usuario del sistema (anular - sin uso)
          this.activateAction.deleteUserSystem = this.as.confirmPermission(
            Const.types_permissions.administrationMasterTables,
            Const.types_action_permissions.deleteUserSystem,
          );
          
          // Permiso para construir la estructura de las maestras
          this.activateAction.buildStructure = this.as.confirmPermission(
            Const.types_permissions.administrationMasterTables,
            Const.types_action_permissions.buildStructure,
          );
          
          // Permiso para ver la estructura de las maestras
          this.activateAction.reviewStructure = this.as.confirmPermission(
            Const.types_permissions.administrationMasterTables,
            Const.types_action_permissions.reviewStructure,
          );
          
          // Permiso para eliminar campos de la estructura de la maestra
          this.activateAction.deleteStructure = this.as.confirmPermission(
            Const.types_permissions.administrationMasterTables,
            Const.types_action_permissions.deleteStructure,
          );
          
        } else {
          // Permiso de creacion de registros en las maestras
          this.activateAction.created = this.as.confirmPermission(
            Const.types_permissions.administrationMasterTables,
            Const.types_action_permissions.created,
          );

          // Permiso de ver los registros de las maestras
          this.activateAction.review = this.as.confirmPermission(
            Const.types_permissions.administrationMasterTables,
            Const.types_action_permissions.review,
          );

          // Permiso para modificar los registros en las maestras
          this.activateAction.update = this.as.confirmPermission(
            Const.types_permissions.administrationMasterTables,
            Const.types_action_permissions.update,
          );
          
          // Permiso para eliminar los registros en las maestras
          this.activateAction.delete = this.as.confirmPermission(
            Const.types_permissions.administrationMasterTables,
            Const.types_action_permissions.delete,
          );
          
          // Permiso para crear usuario del sistema
          this.activateAction.createUserSystem = this.as.confirmPermission(
            Const.types_permissions.administrationMasterTables,
            Const.types_action_permissions.createUserSystem,
          );
          
          // Permiso para ver los usuarios del sistema
          this.activateAction.reviewUserSystem = this.as.confirmPermission(
            Const.types_permissions.administrationMasterTables,
            Const.types_action_permissions.reviewUserSystem,
          );
          
          // Permiso para modificar los usuarios del sistema
          this.activateAction.updateUserSystem = this.as.confirmPermission(
            Const.types_permissions.administrationMasterTables,
            Const.types_action_permissions.updateUserSystem,
          );

          // Permiso para eliminar usuario del sistema (anular - sin uso)
          this.activateAction.deleteUserSystem = this.as.confirmPermission(
            Const.types_permissions.administrationMasterTables,
            Const.types_action_permissions.deleteUserSystem,
          );
          
          // Permiso para construir la estructura de las maestras
          this.activateAction.buildStructure = this.as.confirmPermission(
            Const.types_permissions.administrationMasterTables,
            Const.types_action_permissions.buildStructure,
          );
          
          // Permiso para ver la estructura de las maestras
          this.activateAction.reviewStructure = this.as.confirmPermission(
            Const.types_permissions.administrationMasterTables,
            Const.types_action_permissions.reviewStructure,
          );
          
          // Permiso para eliminar campos de la estructura de la maestra
          this.activateAction.deleteStructure = this.as.confirmPermission(
            Const.types_permissions.administrationMasterTables,
            Const.types_action_permissions.deleteStructure,
          );
        }
      

    




    // consulta general
    // Permiso de creacion de registros en las maestras
   /* this.activateAction.created = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.created,
    );

    // Permiso de ver los registros de las maestras
    this.activateAction.review = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.review,
    );

    // Permiso para modificar los registros en las maestras
    this.activateAction.update = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.update,
    );
    
    // Permiso para eliminar los registros en las maestras
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.delete,
    );
    
    // Permiso para crear usuario del sistema
    this.activateAction.createUserSystem = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.createUserSystem,
    );
    
    // Permiso para ver los usuarios del sistema
    this.activateAction.reviewUserSystem = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.reviewUserSystem,
    );
    
    // Permiso para modificar los usuarios del sistema
    this.activateAction.updateUserSystem = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.updateUserSystem,
    );

    // Permiso para eliminar usuario del sistema (anular - sin uso)
    this.activateAction.deleteUserSystem = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.deleteUserSystem,
    );
    
    // Permiso para construir la estructura de las maestras
    this.activateAction.buildStructure = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.buildStructure,
    );
    
    // Permiso para ver la estructura de las maestras
    this.activateAction.reviewStructure = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.reviewStructure,
    );
    
    // Permiso para eiminar campos de la estructura de la maestra
    this.activateAction.deleteStructure = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.deleteStructure,
    ); */
    // Fin
  // })
  }
 
  private definePermissionsStructure() {
    // consulta general
    // Permiso de creacion de registros en las maestras
   /* this.activateAction.created = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.created,
    );*/

    // Permiso de ver los registros de las maestras
    this.activateAction.review = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.review,
    );

   /* // Permiso para modificar los registros en las maestras
    this.activateAction.update = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.update,
    );
    
    // Permiso para eliminar los registros en las maestras
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.delete,
    );
    */
    // Permiso para crear usuario del sistema
    this.activateAction.createUserSystem = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.createUserSystem,
    );
    
    // Permiso para ver los usuarios del sistema
    this.activateAction.reviewUserSystem = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.reviewUserSystem,
    );
    
    // Permiso para modificar los usuarios del sistema
    this.activateAction.updateUserSystem = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.updateUserSystem,
    );

    // Permiso para eliminar usuario del sistema (anular - sin uso)
    this.activateAction.deleteUserSystem = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.deleteUserSystem,
    );
    
    // Permiso para construir la estructura de las maestras
    this.activateAction.buildStructure = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.buildStructure,
    );
    
    // Permiso para ver la estructura de las maestras
    this.activateAction.reviewStructure = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.reviewStructure,
    );
    
    // Permiso para eiminar campos de la estructura de la maestra
    this.activateAction.deleteStructure = this.as.confirmPermission(
      Const.types_permissions.administrationMasterTables,
      Const.types_action_permissions.deleteStructure,
    ); 
    // Fin
  
  }

  /**
   * Validad la informacion a guardar de la maestra
   *
   * @private
   * @param {*} data
   * @param {ColumnaMaestra[]} form
   * @returns {boolean}
   * @memberof TeacherComponent
   */
  private validDataForm(data: any, form: ColumnaMaestra[]): boolean {
    let valid = true;
    if (form.length) {
      const formulario = this.currentForm;
      for (const field of form) {
        if (typeof field.tipo_campo === 'object' && field.tipo_campo.nombre === 'number') {
          if (data[field.id + ' '] !== undefined) {
            data[field.id + ' '] = Number(data[field.id + ' ']);
          }
        } else if (typeof field.tipo_campo === 'object' && field.tipo_campo.nombre === 'checkbox') {
          if (data[field.id + ' '] !== undefined) {
            if (
              typeof data[field.id + ' '] !== 'boolean' &&
              (data[field.id + ' '] === 'true' || data[field.id + ' '] === 'false')
            ) {
              switch (data[field.id + ' ']) {
                case 'true':
                  data[field.id + ' '] = true;
                  break;
                default:
                  data[field.id + ' '] = false;
                  break;
              }
            } else {
              data[field.id + ' '] = false;
            }
          } else {
            data[field.id + ' '] = false;
          }
        }
        const hiddenField = this.getHiddenField(this.controls, String(field.id) + ' ');
        if (data[field.id + ' '] === undefined || hiddenField === 1 || hiddenField === -1) {
          if (data[field.id + ' '] === undefined) {
            if (typeof field.tipo_campo === 'object' && field.tipo_campo.nombre === 'checkbox') {
              if (formulario.controls[field.id + ' '].value) {
                data[field.id + ' '] = formulario && formulario.controls[field.id + ' '].value;
              } else {
                data[field.id + ' '] = false;
              }
            }
          }
          continue;
        } else {
          if (typeof field.tipo_campo === 'object' && field.tipo_campo.nombre === 'checkbox') {
            if (field.requerido && !formulario.controls[field.id + ' '].disabled) {
              if (!data[field.id + ' ']) {
                this.toastr.warning(
                  'Hay campos requeridos sin llenar, verifique e inténtelo de nuevo',
                  'Información incompleta', {
                    positionClass: 'toast-top-center'
                  }
                );
                formulario.controls[field.id + ' '].setValue(null);
                valid = false;
                break;
              }
            }
          }
        }
      }
    }
    return valid;
  }

  /**
   * Consulta si un campo dentro de un formulario esta oculto
   * 1 = Si
   * 0 = No
   * -1 = Campo no encontrado
   *
   * @private
   * @param {Array<BaseControl<Partial>>} form
   * @param {string} nameField
   * @returns {number}
   * @memberof TeacherComponent
   */
  private getHiddenField(
    form: Array<BaseControl<Partial>>,
    nameField: string
  ): number {
    let hidden = -1;
    form.forEach(field => {
      if (field.controlType !== 'container') {
        if (field.key === nameField) {
          if (field.hiddenCondiction) {
            hidden = 1;
          } else {
            hidden = 0;
          }
        }
      } else {
        hidden = this.getHiddenField(field['controls'], nameField);
      }
    });
    return hidden;
  }

  pageChange(pageIndex:any,master:InformacionTablaMaestra) {
    let loadedRecordCount = this.sourceData.count();
    let lastRequestedRecordIndex = pageIndex * this.pageSize;
  
    if (loadedRecordCount <= lastRequestedRecordIndex) {    
      let startIndex =  loadedRecordCount + 1;
      let recordCount = lastRequestedRecordIndex + 100; //extra 100 records improves UX.
  
      this.tds.getInformacionBasicMasterTable(this.tableSelect.id,startIndex,recordCount) //.toPromise()
        .then(async data => {
          if (this.sourceData.count() > 0){
            await this.asyncForEach(this.structureMaster, async (field: ColumnaMaestra) => {
              await this.loadingSelectsTablePrincipal(field, master, data);
            });
            // const dataValues: Array<any> = [];
            data.forEach(col => {
              col.datos['id'] = col.id;
              if (this.masterTableUsers) {
                col.datos['user_login'] = col.user_login;
                if (col.user_login) {
                  col.datos['login'] = 'Sí';
                } else {
                  col.datos['login'] = 'No';
                }
              }
              this.sourceData.add(col.datos);
            });
            // forEach(data, d => this.sourceData.add(d));
            // this.sourceData.getAll()
            // .then(d => this.sourceData.load(d))
            this.sourceData.getAll().then(d => this.sourceData.load(d))
        }
          else{
            this.sourceData.load(data);
          }
        })
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/teacher/teacher.component.ts